import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Cookie} from 'ng2-cookies/ng2-cookies';
import {ResearchListItem} from './entity/research-list-item';
import {ListResearchesResponse} from './entity/list-researches-response';
import {Observable} from 'rxjs';
import {SearchResearchesRequest, SearchResearchesResponse} from './entity/search-researches';
import {Research} from './entity/research';
import {CreateResearchRequest, CreateResearchResponse, UpdateResearchRequest, UpdateResearchResponse} from './entity/post-research';

@Injectable({
  providedIn: 'root'
})
export class ResearchService {

  static fixDates(research: Research): Research {
    if (research.registerDate) {
      research.registerDate = new Date(Date.parse(research.registerDate.toString()));
    }
    if (research.conclusionDate) {
      research.conclusionDate = new Date(Date.parse(research.conclusionDate.toString()));
    }

    return research;
  }

  constructor(private http: HttpClient) { }

  listResearches(pageNumber = 0, pageSize = 1, filter = '', sortOrder = 'dsc'): Observable<ListResearchesResponse> {
    return  this.http.get<ListResearchesResponse>('http://localhost:12320/research/', {
      params: new HttpParams()
        .set('page', pageNumber.toString())
        .set('size', pageSize.toString()),
      headers: {
        Authorization: 'Bearer ' + Cookie.get('access_token'),
        'Content-Type': 'application/json'
      }
    }).pipe(
      map(response =>  {
        console.log('ListResearchesResponse:', response);
        response.researches.forEach(item => {
          let regDate = null;
          if (item.registerDate) {
            regDate = new Date(Date.parse(item.registerDate.toString()));
          }
          item.registerDate = regDate;
        });
        return response;
      })
    );
  }

  searchResearches(request: SearchResearchesRequest): Observable<SearchResearchesResponse> {
    return this.post<SearchResearchesRequest, SearchResearchesResponse>('/search', request).pipe(
      map(response => {
        response.researches.forEach(item => ResearchService.fixDates(item));
        return response;
      })
    );
  }

  updateResearch(research: Research): Observable<UpdateResearchResponse> {
    return this.post<UpdateResearchRequest, UpdateResearchResponse>('/' + research.id, {'research': research}).pipe(
      map(response => {
        response.research = ResearchService.fixDates(response.research);
        return response;
      })
    );
  }

  createResearch(research: Research): Observable<CreateResearchResponse> {
    return this.post<CreateResearchRequest, CreateResearchResponse>('', {'research': research}).pipe(
      map(response => {
        response.research = ResearchService.fixDates(response.research);
        return response;
      })
    );
  }

  post<T, R>(path: string, request: T): Observable<R> {
    return this.http.post<R>('http://localhost:12320/research' + path, request, {
      headers: {
        Authorization: 'Bearer ' + Cookie.get('access_token'),
        'Content-Type': 'application/json'
      }
    });
  }


}
